import { z } from 'zod/v4';

import { AttributeDTO } from '../attribute/types';
import { CITypeDTO } from './types';
import { CILinkDTO } from '../ci-link/types';

export const CITypeLinkDTO = z.object({
  id: z.uuid(),
  link_id: z.string(),
  src_type_id: z.string(),
  dst_type_id: z.string(),
  parser: z.boolean().optional().default(false),
  support_chr: z.boolean(),
  inherited: z.boolean(),
  like_parent: z.boolean(),
  // attributes: z.array(AttributeDTO),
  configured: z.boolean().optional(),
  // If AttributeFetcherDTO exports Zod schema, destruct accordingly:
  config_fetcher: z.string(), // AttributeFetcherDTO['name'] assumed string
  fetcher_arguments: z.any(), // AttributeFetcherDTO['arguments'], use proper schema if available
  count: z.number(),
  del_count: z.number().optional().default(0),
});
export type CITypeLink = z.infer<typeof CITypeLinkDTO>;

// Связи для списка ТКЕ приходят без количества связей КЕ: их считать дорого
export const CITypesLinkDTO = CITypeLinkDTO.omit({
  count: true,
  del_count: true,
});
export type CITypesLink = z.infer<typeof CITypesLinkDTO>;

export const CITypeLinkSchemaDTO = CITypeLinkDTO.omit({
  link_id: true,
  src_type_id: true,
  dst_type_id: true,
}).extend({
  link: CILinkDTO,
  src_type: CITypeDTO,
  dst_type: CITypeDTO,
});
export type CITypeLinkSchema = z.infer<typeof CITypeLinkSchemaDTO>;

export const CITLinkSettingFullResponseDTO = z.object({
  cit_filter: z.looseObject({}), // any object
  ci_types_link_id: z.uuid(),
  inherited: z.boolean(),
  like_parent: z.boolean(),
});
export type CITLinkSettingFullResponse = z.infer<
  typeof CITLinkSettingFullResponseDTO
>;

export const CITLinkSettingRequestDTO = z.object({
  cit_filter: z.looseObject({}),
  cit_filter_params: z.looseObject({}).optional(),
});
export type CITLinkSettingRequest = z.infer<typeof CITLinkSettingRequestDTO>;

export const CITLinkSettingResponseDTO = z.object({
  cit_filter: z.object({
    filter: z.object({
      filter: z.record(z.string(), z.any()),
      cits: z.record(z.string(), z.any()),
      links: z.boolean(),
    }),
    schema: z.object({
      nodes: z.array(z.any()), // You can make these z.array(NodeDTO) if you have zod schema for Node
      edges: z.array(z.any()), // or z.array(EdgeDTO)
      links: z.boolean(),
    }),
  }),
  cit_filter_params: z.record(z.string(), z.any()),
  inherited: z.boolean(),
  like_parent: z.boolean(),
});
export type CITLinkSettingResponse = z.infer<typeof CITLinkSettingResponseDTO>;

export const CITypeLinkUpdateRequestItemDTO = z.object({
  dst_type_id: z.uuid(),
  link_id: z.uuid(),
  like_parent: z.boolean().optional().default(false),
  id: z.uuid().optional(),
  support_chr: z.boolean().optional().default(false),
  attribute_ids: z.array(z.string()).optional(),
});
export type CITypeLinkUpdateRequestItem = z.infer<
  typeof CITypeLinkUpdateRequestItemDTO
>;

export const CITypeLinksUpdateRequestDTO = z.object({
  links: z.array(CITypeLinkUpdateRequestItemDTO),
  force_delete_link_values: z.boolean(),
});
export type CITypeLinksUpdateRequest = z.infer<
  typeof CITypeLinksUpdateRequestDTO
>;

export const CITypeLinkAttributeDTO = AttributeDTO.extend({
  configured: z.boolean(),
});
export type CITypeLinkAttribute = z.infer<typeof CITypeLinkAttributeDTO>;
export const CITypeLinksGraphSourceDTO = z.object({
  ci_type_id: z.uuid(),
  count: z.number(),
  del_count: z.number(),
});
export type CITypeLinksGraphSource = z.infer<typeof CITypeLinksGraphSourceDTO>;

export const CITypeLinksGraphEdgeDTO = z.object({
  id: z.uuid(),
  link_id: z.uuid(),
  src_type_id: z.uuid(),
  dst_type_id: z.uuid(),
  like_parent: z.boolean(),
  /** ТКЕ, у которого объявлена унаследованная связь */
  inherited_from: z.uuid().nullable().optional(),
  /** Связи КЕ источника и его наследников, как на вкладке связей */
  count: z.number(),
  del_count: z.number(),
  /** Для входящей связи: источник и наследники с копиями связи */
  sources: z.array(CITypeLinksGraphSourceDTO),
});
export type CITypeLinksGraphEdge = z.infer<typeof CITypeLinksGraphEdgeDTO>;

export const CITypeLinksGraphDTO = z.object({
  ci_type_id: z.uuid(),
  edges: z.array(CITypeLinksGraphEdgeDTO),
});
export type CITypeLinksGraph = z.infer<typeof CITypeLinksGraphDTO>;
